import { render, staticRenderFns } from "./ClientPortfolioSelectEmployees.vue?vue&type=template&id=63587460"
import script from "./ClientPortfolioSelectEmployees.vue?vue&type=script&lang=js"
export * from "./ClientPortfolioSelectEmployees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports